<template>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
<!-- <path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/> -->
<path fill="none" d="M0,0h24v24H0V0z"/>
<path d="M2,17h20v-2H2V17z M2,7v2h20V7H2z"/>
<!-- <path d="M0,0H24V24H0Z" transform="translate(0 0)" fill="none"/><path d="M3,17H21V15H3Zm0-4H21V11H3ZM3,7V9H21V7Z" transform="translate(0 0)"/> -->
<!-- <path :fill="color" d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/> -->
</svg>
</template>

<script>
export default {
  name: 'icon-menu',
  // props: [ 'color', ],
};
</script>

<style lang="scss" scoped>
</style>